<template>
  <v-dialog v-model="widgetDialog" max-width="500">
    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-4">
        <h2 v-if="newWidget">Add a new widget to your dashboard</h2>
        <h2 v-else>Configure your {{widget.type}} widget</h2>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 pt-1 pb-0">
        <v-flex xs12>
          <h3 class="pb-2 mr-2 d-inline-block">
            <span class="mr-1" style="font-weight: 700">Step 1</span>
            - What type of widget are you adding?
          </h3>
          <v-flex xs12 px-0 py-0 mb-2>
            <v-flex xs12>
              <v-radio-group class="mt-1" v-model="widget.type" mandatory>
                <v-radio
                  color="secondary"
                  label="Number"
                  value="number"
                ></v-radio>
                <v-radio
                  color="secondary"
                  label="Trendline"
                  value="trend"
                ></v-radio>
                <v-radio
                  color="secondary"
                  label="Pie Chart"
                  value="piechart"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex xs12 v-if="widget.type">
          <h3 class="pb-2 mr-2 d-inline-block">
            <span class="mr-1" style="font-weight: 700">Step 2</span>
            - Select a metric
          </h3>
          <v-flex xs12 px-0 py-0 mb-0>
            <v-flex xs12>
              <v-autocomplete
                box
                dense
                v-model="widget.metricId"
                persistent-hint
                :items="availableMetrics"
                item-text="name"
                item-value="id"                
                label="Select metric"
                no-data-text="No metrics available"
                append-icon="keyboard_arrow_down"
              >
              </v-autocomplete>
            </v-flex>
          </v-flex>
          <v-flex v-if="widget.metricId && widget.type==='number'">
            <h3 class="pb-2 mr-2 d-inline-block">
              <span class="mr-1" style="font-weight: 700">Step 3</span>
              - Label the number
            </h3>
            <v-flex xs12 px-0 py-0 mb-0>
              <v-flex xs12>

                <v-text-field
                  v-model="widget.prefix"
                  placeholder="E.g. £"
                  label="Prefix"
                  box
                ></v-text-field>
                <v-text-field
                  v-model="widget.suffix"
                  placeholder="E.g. kg"
                  label="Suffix"
                  box
                ></v-text-field>
                <v-text-field
                  v-model="widget.scale"
                  type="number"
                  placeholder="How many decimal points?"
                  label="How many decimal points?"
                  box
                ></v-text-field>
                </v-autocomplete>
              </v-flex>
            </v-flex>
          </v-flex>

          <v-flex xs12 v-if="widget.metricId && widget.type==='trend'">
            <h3 class="pb-2 mr-2 d-inline-block">
              <span class="mr-1" style="font-weight: 700">Step 3</span>
              - Select time interval
            </h3>
            <v-flex xs12 px-0 py-0 mb-2>
              <v-flex xs12>
                <v-autocomplete
                  box
                  dense
                  v-model="widget.timeInterval"
                  persistent-hint
                  :items="availableTimeIntervals"
                  label="Select time interval"
                  no-data-text="No time intervals available"
                  append-icon="keyboard_arrow_down"
                >
                </v-autocomplete>
              </v-flex>
            </v-flex>
          </v-flex>

          <v-flex xs12 v-if="widget.metricId">
            <h3 class="pb-2 mr-2 d-inline-block">
              <span class="mr-1" style="font-weight: 700" v-if="hasStep3">Step 4</span>
              <span class="mr-1" style="font-weight: 700" v-else>Step 3</span>
              - Select widget style
            </h3>
            <v-flex xs12 px-0 py-0 mb-2>
              <v-flex xs12>
                <v-radio-group class="mt-1" v-model="widget.style" mandatory>
                  <v-radio
                    color="secondary"
                    label="Just a border"
                    value="outline"
                  ></v-radio>
                  <v-radio
                    color="secondary"
                    label="White Background"
                    value="white"
                  ></v-radio>
                  <v-radio
                    color="secondary"
                    label="Blue Background"
                    value="blue"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-flex>
          </v-flex>

          <v-flex v-if="widget.metricId">
            <h3 class="pb-2 mr-2 d-inline-block">
              <span class="mr-1" style="font-weight: 700" v-if="hasStep3">Step 4</span>
              <span class="mr-1" style="font-weight: 700" v-else>Step 3</span>
              - Specify width &amp; height
            </h3>
            <v-flex xs12 px-0 py-0 mb-0>
              <v-flex xs12>
                <v-layout row >

                  <v-autocomplete
                    box
                    dense
                    v-model="widget.width"
                    persistent-hint
                    :items="availableWidths"
                    label="Select width"
                    append-icon="keyboard_arrow_down"
                  >
                  </v-autocomplete>

                  <v-spacer/>

                  <v-autocomplete
                    box
                    dense
                    v-model="widget.height"
                    persistent-hint
                    :items="availableHeights"
                    label="Select height"
                    append-icon="keyboard_arrow_down"
                  >
                  </v-autocomplete>

                </v-layout>
              </v-flex>
            </v-flex>
          </v-flex>


        </v-flex>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 pt-1">
        <v-btn :disabled="widget.style === null" color="success" @click="addNewWidget()" v-if="newWidget">Add widget</v-btn>
        <v-btn :disabled="widget.style === null" color="success" @click="updateWidget()" v-else>Update widget</v-btn>
        <v-btn @click="cancel()" color="error"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'


export default {
  name: "AddWidgetDialog",
  props: {
    widgetDialog: {
      type: Boolean,
      required: true
    },
    widget: {
      type: Object,
      required: true
    }
  },
  computed: {
    newWidget() {
      return !this.widget.id
    },
    widgetType() {
      return this.widget.type
    },
    hasStep3() {
      return this.widget.type==='number' || this.widget.type==='trend'
    },
    isTrend() {
      return this.widget.type==='trend'
    },
    isNumber() {
      return this.widget.type==='trend'
    },
    availableMetrics() {
      return this.metrics ? this.metrics.filter(m => m.type === 'Bucket') : []
    },
    ...mapState({
      caseTypes: state => state.caseTypes.all,
      metrics: (state) => state.metrics.all
    }),
  },
  methods: {
    ensureNumbers() {
      this.widget.width=parseInt(this.widget.width, 10)
      this.widget.height=parseInt(this.widget.height, 10)
    },
    addNewWidget() {
      this.ensureNumbers()
      this.$store.dispatch("addNewWidget", this.widget)
      this.$emit("new-widget-added")
    },
    updateWidget() {
      this.ensureNumbers()
      this.$store.dispatch("updateWidget", this.widget)
      this.$emit("new-widget-added")
    },
    cancel() {
      this.$emit("new-widget-cancelled")
    }
  },
  watch: {
    widgetType() {
      if (this.widgetType==="trend") {
        if (!this.widget.timeInterval) {
          this.widget.timeInterval="day"
        }
      } else {
        this.widget.timeInterval=undefined
      }
    }
  },
  data: () => ({
    bucketSelected: undefined,
    fieldSelected: null,
    widgetStyle: "border",
    availableTimeIntervals: ['day', 'week', 'month'],
    availableHeights: [1, 2, 3],
    availableWidths: [1, 2, 3]
  })
}
</script>